export const CodeStatus = Object.freeze({
    A: Symbol('A'),
    C: Symbol('C'),
    D: Symbol('D'),
    G: Symbol('G'),
    I: Symbol('I'),
});

/**
 * Results of this method can be used in <v-select> fields.
 */
export function getItems(includeGenerated = false, value = 'value', text = 'text') {
    let items = [];
    const statuses = Object.getOwnPropertyNames(CodeStatus);

    for (const status of statuses) {
        if (!includeGenerated && CodeStatus.G === status) {
            continue;
        }

        items.push({[value]: status, [text]: getStatusText(status)});
    }

    return items;
}

export function getStatusText(status) {
    return {
        [CodeStatus.A]: 'Aktywny',
        [CodeStatus.C]: 'Anulowany',
        [CodeStatus.D]: 'Zużyty',
        [CodeStatus.G]: 'Nowy',
        [CodeStatus.I]: 'Nieaktywny',
    }[CodeStatus[status]];
}
